export const Routing = {
  Initial: "/",
  Login: "/login",
  Dashboard: "/dashboard",
  ImportData: "/import",
  Creators: "/creators",
  Agents: "/agents",
  changeLanguage: "/changelanguage"
};
